import { Component } from '@angular/core';
import { BlankLayoutComponent } from 'app/components/common/layouts/blankLayout.component';

@Component({
  selector: 'psm-user-layout',
  templateUrl: 'userLayout.component.html',
  styleUrls: ['userLayout.component.scss']
})
export class UserLayoutComponent extends BlankLayoutComponent {}



// WEBPACK FOOTER //
// ./src/app/components/common/layouts/userLayout.component.ts